'use strict';
import { combineReducers } from 'redux';
import { configuration } from './configuration';
import { discoveryPanels } from '../../discovery-panel/redux/reducers/discoveryPanels.reducer';

import { filesReducer } from './files.reducer';
import { formReducer } from './form.reducer';
import { enrichmentFilterReducer } from './enrichmentFilter.reducer';
import currentUser from './currentUser.reducer';
import { availableRolesReducer } from './availableRoles.reducer';
import { managedProjectsReducer } from './managedProjects.reducer';
import { sampleSetDataReducer } from './sampleSetData.reducer';
import { searchResultsReducer } from './searchResults.reducer';
import { publishSummaryReducer, projectsReducer } from './projects.reducer';
import { portalApi } from '../services/portal/index.api';
import '../services/portal/files.api';
import '../services/portal/pipelineStatus.api';
import { pathwayExplorerApi } from '../services/pathwayexplorer/index.api';
import { discoveryApi } from '../services/discovery/index.api';
import { biovizApi } from '../services/bioviz.api';
import userProfileReducer from './userProfile.reducer';

export const rootReducer = combineReducers({
		userProfile: userProfileReducer,
    availableRoles: availableRolesReducer,
    configuration,
		enrichmentFilter: enrichmentFilterReducer,
    files: filesReducer,
    form: formReducer,
    currentUser,
    managedProjects: managedProjectsReducer,
    projects: projectsReducer,
    publishSummary: publishSummaryReducer,
    sampleSetData: sampleSetDataReducer,
    searchResults: searchResultsReducer,
    discoveryPanels,
		[pathwayExplorerApi.reducerPath]: pathwayExplorerApi.reducer,
		[discoveryApi.reducerPath]: discoveryApi.reducer,
    [portalApi.reducerPath]: portalApi.reducer,
		[biovizApi.reducerPath]: biovizApi.reducer,
});
